import React, { useContext } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import UserContext from "../../components/UserContext";
import { getLearnPosts, getPosts } from "../../services/data";
import LearnCard from "../../components/blog/LearnCard";

export default function Layout(props) {
    const { user, supabase } = useContext(UserContext);
    return (
        <div>
            <div className="relative bg-white dark:bg-gray-900">
                <div className="container mx-auto">
                    <Header
                        {...props}
                        supabase={supabase}
                        user={user}
                        title="Learn more - VectorArt.ai"
                        className="secondary w-full"
                        highlightCreateButton={true}
                    />
                </div>
            </div>

        
            <div className="px-4 sm:px-0 w-full bg-white dark:bg-gray-950 py-8 md:pt-10 flex flex-col items-center justify-center border-t border-gray-100 dark:border-gray-900">
                <div className="w-full flex flex-1 flex-col mx-auto mb-16">
                    <div className="flex my-8 flex-col mx-4 md:mx-32 xl:mx-96">
                        <h2 className="my-0 mb-2 text-2xl font-medium text-left">
                            Learn more
                        </h2>
                        <div className="flex-1 flex flex-col flex-wrap">
                            {props.learnPosts.map((post) => (
                                <LearnCard
                                    key={post.slug}
                                    title={post.title}
                                    description={post.description}
                                    url={`/learn/${post.slug}`}
                                    date={post.date}
                                    author={post.author}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <Footer {...props} user={user} />
        </div>
    );
}

export async function getStaticProps(context) {
    const posts = await getPosts();
    const learnPosts = await getLearnPosts();
    const featuredPosts = posts.slice(0, 3);
    const otherPosts = posts.slice(3);
    return { props: { featuredPosts, posts: otherPosts, learnPosts } };
}
